/* ZSportsTech — section-science.js
   Full-viewport auto-advancing slider (no manual scroll).
   Cards cycle automatically; pause on hover/focus; segments jump.
   Vanilla JS only. Maps to → assets/section-science.js */
(function () {
  'use strict';

  function init() {
    var section  = document.getElementById('sc-science');
    var track    = document.getElementById('sc-science-track');
    var progress = document.getElementById('sc-science-progress');
    if (!section || !track || !progress) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.sc-science__card'));
    var segs  = Array.prototype.slice.call(progress.querySelectorAll('.sc-science__seg'));
    if (!cards.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0;

    function show(i) {
      idx = (i + cards.length) % cards.length;
      track.style.transform = 'translateX(' + (-cards[idx].offsetLeft) + 'px)';
      segs.forEach(function (seg, k) {
        seg.classList.toggle('sc-science__seg--active', k === idx);
      });
    }

    /* Auto-advance (pause on hover/focus) */
    var timer = null, paused = false;
    function tick() { if (!paused && !reduce) show(idx + 1); }
    function start() { if (reduce) return; stop(); timer = setInterval(tick, 3500); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    section.addEventListener('pointerenter', function () { paused = true; });
    section.addEventListener('pointerleave', function () { paused = false; });
    section.addEventListener('focusin', function () { paused = true; });
    section.addEventListener('focusout', function () { paused = false; });

    /* Segment click → jump */
    segs.forEach(function (seg) {
      seg.addEventListener('click', function () {
        show(parseInt(seg.getAttribute('data-seg'), 10) || 0);
        restart();
      });
    });

    /* Keyboard arrows */
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); restart(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); restart(); }
    });

    /* Touch swipe (mobile) */
    var sx = 0, sy = 0, swiping = false;
    track.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; swiping = true;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (!swiping) return; swiping = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        show(dx < 0 ? idx + 1 : idx - 1);
        restart();
      }
    }, { passive: true });

    /* Keep alignment on resize */
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { show(idx); }, 120);
    });

    show(0);
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
}());
